'use strict';/* global define */define('modules/departments/states/admin_departments/index',['require','exports','module','./controller','text!./template.html'],function(require,exports,module){'use strict';var state={url:'/departments',views:{'body@app':{controller:require('./controller'),controllerAs:'AdminDepartmentsCtrl',template:require('text!./template.html')}}// data : {
// },
// meta : {
//   icon : '',
//   label : '',
//   menu : true
// },
// resolve : {
// },
};module.exports=state;});
